module.exports = require('./components/Modal');




/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-modal/lib/index.js
 ** module id = 2861
 ** module chunks = 0
 **/